import { Component, OnInit } from '@angular/core';
import { INotification, INotificationListResponse } from 'src/app/models/dashboard.models';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
  selector: 'app-notification-mom',
  templateUrl: './notification-mom.component.html',
  styleUrls: ['./notification-mom.component.scss']
})
export class NotificationMomComponent implements OnInit {

  notifications: Array<INotification> = [];
  LIMIT: number = 20;
  loading: boolean;
  fetchedAll: boolean = false;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit(): void {
    this.fetchedAll = false;
    this.getNotifications();
  }

  getNotifications(){
    if(!this.fetchedAll){
      let body = {
        limit: this.LIMIT,
        offset: this.notifications.length
      }
      this.loading = true;
      
      this.dashboardService.getNotificationsMum(body)
      .subscribe((res: INotificationListResponse)=>{
        this.fetchedAll = res.payload.length < this.LIMIT ? true : false;
        res.payload.forEach(notify => {
          let temp = new Date(notify.date);
          temp.setHours(temp.getHours() - 7);
          temp.setMinutes(temp.getMinutes() - 30);
          notify.date = temp;
        });
        this.loading = false;
        this.notifications = this.notifications.concat(res.payload);
        console.log("Notifications Mum:", res.payload);
      },err=>{
        console.error("Notifications Mum Error", err);
        this.loading = false;
      });
    }
  }
}
